interface Props {
  symbols: string[]
  selected: string
  onSelect: (symbol: string) => void
}

export function SymbolTabs({ symbols, selected, onSelect }: Props) {
  return (
    <div className="journal-view-toggle" style={{ marginBottom: 'var(--space-md)' }}>
      {symbols.map(sym => (
        <button
          key={sym}
          className={selected === sym ? 'active' : ''}
          onClick={() => onSelect(sym)}
        >
          {sym}
        </button>
      ))}
    </div>
  )
}
